import { DEFAULT_AUTH_DOMAIN, LMS_DOMAIN } from "@/lib/course/utils/constants";
import { getEnv } from "@/env";

const getTrackSelectionUrl = (
  courseRunKey: string,
  category?: string,
  courseSlug?: string,
  useNewTrackSelect?: string | boolean,
  emailOptIn?: boolean,
) => {
  if (useNewTrackSelect === true || useNewTrackSelect === "true") {
    const SITE_DOMAIN = getEnv("NEXT_PUBLIC_SITE_URL", "https://www.edx.org"); // Current domain
    const AUTH_DOMAIN = getEnv("NEXT_PUBLIC_AUTH_DOMAIN", DEFAULT_AUTH_DOMAIN); // Current domain
    const baseUrl = `${AUTH_DOMAIN}/register?next=`;
    const destinationUrl = `${SITE_DOMAIN}/track-select/${category}/${courseSlug}/?emailOptIn=${emailOptIn}&courseRunKey=${courseRunKey}`;
    return baseUrl + encodeURIComponent(destinationUrl);
  }

  const trackSelectionUrl = `${LMS_DOMAIN}/course_modes/choose/`;
  return `${trackSelectionUrl}${encodeURIComponent(courseRunKey)}`;
};

export default getTrackSelectionUrl;
